import * as yup from "yup"

export const SchemaRecover = yup.object().shape({
  email: yup.string().required("O email é obrigatório").email("Email inválido"),
});